import '../scss/frontend.scss';
import AccordionService from './components/accordion-service';
import BackToTopService from './components/back-to-top-service';
import { CartService } from './components/cart-service';
import CheckoutService from './components/checkout-service';
import { CookiesService } from './components/cookies-service';
import DeliveryAndPaymentService from './components/delivery-and-payment-service';
import EmailInputService from './components/email-input-service';
import FormsService from './components/forms-service';
import FullscreenSlidersService from './components/fs-sliders-service';
import HeaderService from './components/header-service';
import MenuService from './components/menu-service';
import ModalService from './components/modal-service';
import { NonceService } from './components/nonce-service';
import PhoneInputService from './components/phone-input-service';
import ProductInfoTabsService from './components/product-info-tabs-service';
import ProductPageBottomStickyService from './components/product-sticky-bottom-service';
import { PromoService } from './components/promo-service';
import RequiredInputService from './components/required-input-service';
import ReviewsService from './components/reviews-service';
import SelectService from './components/select-service';
import Sliders from './components/swiper-init';
import Popup from './parts/popup-window';
function ready() {
    const popupInstance = new Popup();
    const selectService = new SelectService();
    const accordionService = new AccordionService();
    const menuService = new MenuService();
    const cookiesService = new CookiesService();
    const headerService = new HeaderService();
    const productInfoTabsService = new ProductInfoTabsService();
    const productPageBottomStickyService = new ProductPageBottomStickyService();
    const nonceService = new NonceService(perlaData.ajax_url);
    const checkoutService = new CheckoutService();
    const cartService = new CartService();
    const reviewsService = new ReviewsService();
    const deliveryAndPaymentService = new DeliveryAndPaymentService();
    const phoneInputService = new PhoneInputService();
    const emailInputService = new EmailInputService();
    const requiredInputService = new RequiredInputService();
    const modalService = new ModalService();
    const fsService = new FullscreenSlidersService();
    const backToTopService = new BackToTopService();
    const promoService = new PromoService();
    const formsService = new FormsService();
    modalService.init();
    nonceService.init().finally(() => {
        cartService.init();
        reviewsService.init();
        checkoutService.init(modalService);
    });
    headerService.init();
    popupInstance.init();
    selectService.init();
    accordionService.init();
    menuService.init();
    cookiesService.init();
    productInfoTabsService.init();
    productPageBottomStickyService.init();
    formsService.init();
    phoneInputService.init();
    emailInputService.init();
    requiredInputService.init();
    backToTopService.init();
    promoService.init();
    Sliders.initSwiperHeroBanner();
    Sliders.initMarqueeLineSwiper();
    Sliders.initOftenChooseSwiper();
    Sliders.initInstagramReviewSwiper();
    Sliders.initCrossSellsSwiper();
    Sliders.initCartPromoSwiper();
    Sliders.initCertificatesSwiper();
    Sliders.initCatalogueBanner();
    Sliders.initCheckoutSlider();
    const swiper1 = Sliders.initProductSlider();
    setTimeout(() => {
        fsService.init(Sliders, swiper1);
    }, 200);
    deliveryAndPaymentService.init();
}
window.document.addEventListener('DOMContentLoaded', ready);
